import TransactionService from "@/services/TransactionService.js";
import moment from "moment";
import merchant from "./merchant.js";

export default {
    namespaced: true,
    state: {
        transaction_history: {},
        loading: false,
        errors: null,
        max_page: 0,
        currentPage: 0
    },
    mutations: {
        SET_LOADING(state, value) {
            state.loading = value;
        },
        SET_HISTORY(state, history) {
            let transaction_history = [];
            let today = moment().format("D/MM/YYYY");
            let yesterday = moment().subtract(1, 'days').format("D/MM/YYYY");
            let loyalty = merchant.state.isPointsView;
            let types = ['Redeem Reward', 'Achievement Unlock', 'Earn Points', 'Give Points', 'Pay with Points', 'Issue Reward', 'Transfer Points'];

            for (let index = 0; index < history.length; index++) {
                let data = history[index];
                let created_at = moment(data.created_at).format("MMM D");

                if ((loyalty == false && types.includes(data.transaction_type)) || loyalty == true) {
                    if (data.transaction_short_date == today) {
                        if (!('Today' in transaction_history)) {
                            transaction_history['Today'] = [];
                        }
    
                        transaction_history['Today'].push(data);
                    } else if (data.transaction_short_date == yesterday) {
                        if (!('Yesterday, ' + created_at in transaction_history)) {
                            transaction_history['Yesterday, ' + created_at] = [];
                        }
    
                        transaction_history['Yesterday, ' + created_at].push(data);
                    } else {
                        if (!(created_at in transaction_history)) {
                            transaction_history[created_at] = [];
                        }
    
                        transaction_history[created_at].push(data);
                    }
                }
            }

            for (const key in transaction_history) {
                if (key in state.transaction_history) {
                    for (const data in transaction_history[key]) {
                        state.transaction_history[key].push(transaction_history[key][data]);
                    }
                } else {
                    state.transaction_history[key] = transaction_history[key];
                }
            }

        },
        SET_ERRORS(state, errors) {
            state.errors = errors;
        },
        RESET_ERRORS(state) {
            state.errors = null;
        },
        SET_MAX_PAGE(state, maxPage) {
            state.max_page = maxPage;
        },
        SET_CURRENT_PAGE(state, currentPage) {
            state.currentPage = currentPage;
        },
        RESET_TRANSACTION_HISTORY(state) {
            state.transaction_history = {};
            state.currentPage = 1;
        }
    },
    getters: {
        max_page: state => state.max_page,
        transaction_history: state => state.transaction_history
    },
    actions: {
        getTransactionHistory: async ({ commit }, request) => {
          commit("SET_LOADING", true);
          
          try {
              commit("RESET_ERRORS");
              let response = await TransactionService.getTransactionHistory(request);

              commit("SET_HISTORY", response.list)
              commit("SET_MAX_PAGE", response.max_page);
              commit("SET_LOADING", false);
          } catch (errors) {
              commit("SET_ERRORS", errors);
          } finally {
            commit("SET_LOADING", false);
          }
        }
    }
};
